import Loading from './assets/img/loading.png';

export const ICONCOLOR = "#2f82ff";
export const LABELPOSITION = "top";
export const OPEATORALIGN = "left";
export const OPEATORIGHT = "right";
export const LOADING = `<image style="width:100%"  x="0" y="0" xlink:href="${Loading}" />`;